module.exports = __webpack_public_path__ + "img/previous.44adc590.svg";